/**
 * Dynamic Variant Cart Fix
 * Works for ALL products - reads variant IDs from the page
 */

(function() {
  'use strict';
  
  let selectedSize = null;
  let variantMap = {};
  
  // Build variant map dynamically from the page
  function buildVariantMap() {
    variantMap = {};
    
    // Method 1: Read from sticky dropdown (most reliable)
    const dropdown = document.querySelector('select[name="id"]');
    if (dropdown) {
      dropdown.querySelectorAll('option[value]').forEach(option => {
        const variantId = option.value;
        if (!variantId) return;
        
        const text = option.textContent.trim();
        // Extract size from text like "S - $195" or "Small - $195"
        const size = text.split(' -')[0].trim();
        
        if (size && variantId) {
          variantMap[size] = variantId;
        }
      });
    }
    
    // Method 2: Read from radio buttons and their data attributes
    if (Object.keys(variantMap).length === 0) {
      document.querySelectorAll('input[type="radio"][name^="Size-"]').forEach(radio => {
        const size = radio.value;
        const form = document.getElementById(radio.getAttribute('form'));
        if (form) {
          const hiddenInput = form.querySelector('input[name="id"]:not([disabled])');
          if (hiddenInput && hiddenInput.value) {
            variantMap[size] = hiddenInput.value;
          }
        }
      });
    }
    
    // Method 3: Try to read from variant picker JSON
    if (Object.keys(variantMap).length === 0) {
      const variantPicker = document.querySelector('variant-picker');
      if (variantPicker) {
        const variantScript = variantPicker.querySelector('script[type="application/json"]');
        if (variantScript) {
          try {
            const variants = JSON.parse(variantScript.textContent);
            if (Array.isArray(variants)) {
              variants.forEach(variant => {
                if (variant.option1) {
                  variantMap[variant.option1] = variant.id;
                }
              });
            }
          } catch(e) {}
        }
      }
    }
    
    return Object.keys(variantMap).length > 0;
  }
  
  // Initialize on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', buildVariantMap);
  } else {
    buildVariantMap();
  }
  
  // Rebuild when navigating between products (for AJAX themes)
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length > 0) {
        buildVariantMap();
      }
    });
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  
  // Capture size selection
  document.addEventListener('click', function(e) {
    let target = e.target;
    
    for (let i = 0; i < 3; i++) {
      if (!target) break;
      
      // Direct radio button click
      if (target.tagName === 'INPUT' && target.type === 'radio') {
        const name = target.name;
        // Match Size-, Color-, or any option name
        if (name && (name.includes('Size') || name.includes('Option'))) {
          selectedSize = target.value;
          return;
        }
      }
      
      // Label click
      if (target.tagName === 'LABEL') {
        const forId = target.getAttribute('for');
        if (forId) {
          const radio = document.getElementById(forId);
          if (radio && radio.type === 'radio') {
            const name = radio.name;
            if (name && (name.includes('Size') || name.includes('Option'))) {
              selectedSize = radio.value;
              return;
            }
          }
        }
      }
      
      target = target.parentElement;
    }
  }, true);
  
  // Intercept form submission
  document.addEventListener('submit', function(e) {
    const form = e.target;
    
    if (!form.action || !form.action.includes('/cart/add')) {
      return;
    }
    
    e.preventDefault();
    e.stopImmediatePropagation();
    
    // Rebuild map in case it changed
    if (Object.keys(variantMap).length === 0) {
      buildVariantMap();
    }
    
    const variantId = variantMap[selectedSize];
    
    if (!variantId) {
      alert('Please select an option');
      return false;
    }
    
    // Build clean form data
    const formData = new FormData();
    const originalData = new FormData(form);
    
    for (let [key, value] of originalData.entries()) {
      if (key !== 'id') {
        formData.append(key, value);
      }
    }
    
    formData.append('id', variantId);
    
    // Submit
    fetch(form.action, {
      method: 'POST',
      body: formData,
      headers: { 'Accept': 'application/json' }
    })
    .then(response => {
      if (response.ok) {
        // Refresh cart
        if (window.MinimogTheme && window.MinimogTheme.Cart) {
          window.MinimogTheme.Cart.getCart();
        }
        
        // Trigger events
        document.dispatchEvent(new CustomEvent('cart:updated'));
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        
        // Open cart drawer
        setTimeout(() => {
          if (window.MinimogTheme && window.MinimogTheme.Drawer) {
            try {
              window.MinimogTheme.Drawer.open('cart');
            } catch(e) {}
          }
        }, 100);
        
        // Show notification
        if (window.MinimogTheme && window.MinimogTheme.Notification) {
          window.MinimogTheme.Notification.show({
            target: form,
            type: 'success',
            message: window.MinimogStrings?.itemAdded || 'Added to cart!'
          });
        }
      } else {
        throw new Error('Add to cart failed');
      }
    })
    .catch(error => {
      console.error('Cart error:', error);
      alert('Error adding to cart. Please try again.');
    });
    
    return false;
  }, true);
  
})();